module.exports = __webpack_public_path__ + "img/sm.5072d340.svg";